"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactHtmlParser = _interopRequireWildcard(require("react-html-parser"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ThemeProvider = require("../../../components/ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var convertedTagsToDivs = ['html', 'body'];
var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);

var HTMLBlock = function HTMLBlock(_ref) {
  var content = _ref.content,
      className = _ref.className,
      allowList = _ref.allowList,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["content", "className", "allowList"]);
  var classes = useStyles();

  var transform = function transform(node, i) {
    if (node.type === 'tag') {
      if (convertedTagsToDivs.includes(node.name)) return (0, _reactHtmlParser.convertNodeToElement)(_objectSpread(_objectSpread({}, node), {}, {
        name: 'div'
      }), i, transform);
      if ((allowList === null || allowList === void 0 ? void 0 : allowList.length) && !(allowList === null || allowList === void 0 ? void 0 : allowList.includes(node.name))) return null;
    }
  };

  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: (0, _classnames["default"])('HTMLBlock', classes.HTMLBlock, className)
  }, rest), (0, _reactHtmlParser["default"])(content, {
    transform: transform
  }));
};

exports["default"] = HTMLBlock;
//# sourceMappingURL=index.js.map